import { createAction, createReducer } from "@reduxjs/toolkit";

// ACTIONS
const openRequested = createAction("chatCard/openRequested");
const closeRequested = createAction("chatCard/closeRequested");

// INITIAL STATE
const initialState = {
  isOpen: false,
};

// REDUCER
const chatCardReducer = createReducer(initialState, {
  [openRequested.type]: (state) => {
    state.isOpen = true;
  },
  [closeRequested.type]: (state) => {
    state.isOpen = false;
  },
});

// PUBLIC ACTIONS
export const openChatCard = () => openRequested();
export const closeChatCard = () => closeRequested();

export default chatCardReducer;
